export function getDecimalSeparator(locale: string) {
  return Intl.NumberFormat(locale)
    .format(1.1)
    .replace(/\p{Number}/gu, "");
}
